import { IProxyUsage } from '@/features/reports/proxy-usage/proxyUsageSlice'
import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'

export const getProxyUsages = async (params?: any): Promise<IApiResponse<IList<IProxyUsage>>> => {
	const { data } = await axios.get<IApiResponse<IList<IProxyUsage>>>('/api/report/proxy-usage', { params })
	return data
}